import React, { useMemo } from 'react'
import { withJsonFormsLayoutProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { Row } from 'react-bootstrap'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import DragContainerWrapper from 'designer/component/system/layout/control/DragContainerWrapper'
import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'

import {
  createDisplayRenderer,
  createSystemRenderer,
} from 'designer/component/control/renderer'
import FormComponent from 'designer/component/component/FormComponent'

export const TabPanel = (props) => {
  let { data, schema, uischema, config = {}, renderers } = props
  const formCode = uischema?.loadForm?.formCode
  const elements = uischema?.elements || []

  if (formCode) {
    return (
      <FormComponent
        {...props}
        sourceType="form"
        tabDesignCode={formCode}
        config={{ ...config, isFormComponent: true, formComponent: uischema }}
      />
    )
  }

  return (
    <Row className="w-100 mx-0">
      {elements.map((element, index) => (
        <JsonForms
          key={'tab-panel-element-' + (element.key || element.name || index)}
          schema={schema}
          uischema={element}
          data={data}
          renderers={renderers}
          cells={materialCells}
          config={{ ...config, tabKey: uischema.key }}
        />
      ))}
    </Row>
  )
}

export const TabPanelSystem = (props) => {
  const { uischema, config = {} } = props
  const { isLoadTab } = config
  const dropZoneMinHeight =
    !uischema.loadForm?.formCode && !uischema.elements?.length
      ? '120px'
      : undefined
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)]
  )

  return (
    <div
      className="border rounded"
      style={{
        padding: uischema.layoutPadding,
        margin: uischema.layoutMargin,
      }}
    >
      <DragContainerWrapper
        {...props}
        isLoad={isLoadTab}
        dropZoneMinHeight={dropZoneMinHeight}
      >
        <TabPanel {...props} renderers={renderers} />
      </DragContainerWrapper>
    </div>
  )
}

export const SubTabPanelSystem = (props) => {
  const { uischema, config = {} } = props
  const { isLoadTab } = config
  const dropZoneMinHeight =
    !uischema.loadForm?.formCode && !uischema.elements?.length
      ? '120px'
      : undefined
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)]
  )

  return (
    <div
      className="border rounded"
      style={{
        padding: uischema.layoutPadding,
        margin: uischema.layoutMargin,
      }}
    >
      <DragContainerWrapper
        {...props}
        isLoad={isLoadTab}
        dropZoneMinHeight={dropZoneMinHeight}
      >
        <TabPanel {...props} renderers={renderers} />
      </DragContainerWrapper>
    </div>
  )
}

export const TabPanelDisplay = (props) => {
  const { uischema, config = {} } = props
  const elements = uischema.elements
  const { isLoadTab } = config
  const renderers = useMemo(
    () => createDisplayRenderer(elements || []),
    [elements]
  )

  return (
    <div
      className="border rounded"
      style={{
        padding: uischema.layoutPadding,
        margin: uischema.layoutMargin,
      }}
    >
      <ComponentWrapper {...props} isLoad={isLoadTab}>
        <TabPanel {...props} renderers={renderers} />
      </ComponentWrapper>
    </div>
  )
}

export const SubTabPanelDisplay = (props) => {
  const { uischema, config = {} } = props
  const elements = uischema.elements
  const { isLoadTab } = config
  const renderers = useMemo(
    () => createDisplayRenderer(elements || []),
    [elements]
  )

  return (
    <div
      className="border rounded"
      style={{
        padding: uischema.layoutPadding,
        margin: uischema.layoutMargin,
      }}
    >
      <ComponentWrapper {...props} isLoad={isLoadTab}>
        <TabPanel {...props} renderers={renderers} />
      </ComponentWrapper>
    </div>
  )
}

export const tabPanelTester = rankWith(3, scopeEndsWith('tabPanel'))

export const tabPanelSystem = {
  tester: tabPanelTester,
  renderer: withJsonFormsLayoutProps(TabPanelSystem),
}

export const subTabPanelSystem = {
  tester: tabPanelTester,
  renderer: withJsonFormsLayoutProps(SubTabPanelSystem),
}

export const tabPanelDisplay = {
  tester: tabPanelTester,
  renderer: withJsonFormsLayoutProps(TabPanelDisplay),
}

export const subTabPanelDisplay = {
  tester: tabPanelTester,
  renderer: withJsonFormsLayoutProps(SubTabPanelDisplay),
}
